import React from 'react';
import { costFormat } from "../../../services/cost";
import Logos from './logos';
import Info from '../../../components/Info';
import { calcWeight } from './math';
import {getCarrierUiExtension} from "./carrierExtensions";

const ActualCostBlock = ({ parcel }) => {
    const carrierExtension = getCarrierUiExtension(parcel.selectedTariff);
    const shortTariffTitle = carrierExtension.getShortTariffTitle(parcel.selectedTariff);
    const parcelTypes = {
        parcelTypeDoc: 1,
        parcelTypeCargo: 2,
        parcelTypePallets: 22
    };

    const isDoc = parcel.parcelType === parcelTypes.parcelTypeDoc;
    const isPallets = parcel.parcelType === parcelTypes.parcelTypePallets;

    const addressName = (address) => {
        return !address ? '' : `${address.city ? `${address.city}` : ''}`;
    }

    const calcServiceCost = (parcel) => {
        let sum = parcel.actualDeliveryCost || parcel.deliveryCost || 0;

        sum += parcel.discountForCustomer || 0;

        sum -= parcel.insuranceCost || 0;
/*        sum -= parcel.feeUsingYourCarrier || 0;*/
        sum -= parcel.createByManagerCost || 0;

        return sum;
    }

    const serviceNameByCode = {
        loading: 'Погрузка при приёме',
        unloading: 'Разгрузка при доставке',
        lathing: 'Обрешетка',
        additionalPackaging: 'Доупаковка'
    };

    const selectedServiceLines = (() => {
        const selectedCodes = parcel.services || [];
        const tariffServices = ((parcel.selectedTariff || {}).services || []);
        return tariffServices
            .filter(s => selectedCodes.includes(s.code) && serviceNameByCode[s.code])
            .map(s => ({
                code: s.code,
                name: serviceNameByCode[s.code],
                cost: Number.parseFloat(s.cost) || 0
            }));
    })();

    return <div className='cost-calc'>
        <div className='cost-calc__background'>
            <div className='cost-calc__points'>
                <div className='cost-calc__params'>
                    <div className='cost-calc__carrier'>
                        <Logos
                            name={(parcel.selectedTariff || {}).carrierCode}
                            carrierTitle={(parcel.selectedTariff || {}).carrierName}
                        />
                        <div className='carrier-tariff-inline'>
                            <div className='carrier-tariff-inline__title'>{shortTariffTitle}</div>
                            <Info
                                className='carrier-tariff-inline__icon'
                                name={(parcel.selectedTariff || {}).carrierName}
                                label={(parcel.selectedTariff || {}).carrierServiceName}
                                text={(parcel.selectedTariff || {}).carrierServiceDescription}
                                position={'right'}
                                offset={[7]}
                            />
                        </div>
                    </div>
                </div>
                <div className='cost-calc__point'>
                    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M5.60003 14C5.60003 14 11.2 8.09251 11.2 5.21332C11.2 2.33409 8.69282 0 5.60003 0C2.50723 0 0 2.33409 0 5.21329C0 8.09249 5.60003 14 5.60003 14Z"
                            fill="#99D402" />
                        <path
                            d="M5.60006 8.75C6.47525 8.75 7.27542 8.42877 7.88908 7.89778C8.63079 7.256 9.10006 6.3078 9.10006 5.25C9.10006 3.317 7.53305 1.75 5.60006 1.75C3.66706 1.75 2.10006 3.317 2.10006 5.25C2.10006 7.183 3.66706 8.75 5.60006 8.75Z"
                            fill="white" />
                    </svg>
                    <div>
                        {addressName(parcel.shipmentAddress)}
                    </div>
                </div>
                <div className='cost-calc__point'>
                    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M5.60003 14C5.60003 14 11.2 8.09251 11.2 5.21332C11.2 2.33409 8.69282 0 5.60003 0C2.50723 0 0 2.33409 0 5.21329C0 8.09249 5.60003 14 5.60003 14Z"
                            fill="#459EFF" />
                        <path
                            d="M5.60006 8.75C6.47525 8.75 7.27542 8.42877 7.88908 7.89778C8.63079 7.256 9.10006 6.3078 9.10006 5.25C9.10006 3.317 7.53305 1.75 5.60006 1.75C3.66706 1.75 2.10006 3.317 2.10006 5.25C2.10006 7.183 3.66706 8.75 5.60006 8.75Z"
                            fill="white" />
                    </svg>
                    <div>
                        {addressName(parcel.deliveryAddress)}
                    </div>
                </div>
                <div className='cost-calc__params'>
                    {!isDoc ? 'Груз' : 'Документы'}
                </div>
                <div className='cost-calc__params'>
                    {!isDoc && <div className='cost-calc__param'>
                        <div>
                            Кол-во мест:
                        </div>
                        <div className='cost-calc__value'>
                            {(parcel || {}).packagesCount || 0}
                        </div>
                    </div>}
                    {!isDoc && <div className='cost-calc__param'>
                        <div>
                            Общий объем:
                        </div>
                        <div className='cost-calc__value'>
                            {(parcel || {}).volume || 0} м³
                        </div>
                    </div>}
                    <div className='cost-calc__param'>
                        <div>
                            Общий вес:
                        </div>
                        <div className='cost-calc__value'>
                            {(parcel || {}).weight || 0} кг
                        </div>
                    </div>
                    {!isDoc && !isPallets && <div className='cost-calc__param'>
                        <div>
                            Объемный вес:
                        </div>
                        <div className='cost-calc__value'>
                            {calcWeight(parcel)} кг
                        </div>
                    </div>}
                </div>
                <div className='cost-calc__params'>
                    <div className='cost-calc__param'>
                        <div>
                            {parcel.actualDeliveryCost > 0 ? 'Фактическая стоимость отправки' : 'Расчетная стоимость отправки'}
                        </div>
                        <div className='cost-calc__value'>
                            {((parcel.selectedTariff && parcel.selectedTariff.cost) || 0).toFixed(2)} ₽
                        </div>
                    </div>
                    {parcel.insuranceCost > 0 && <div className='cost-calc__param'>
                        <div>
                            Страхование
                        </div>
                        <div className='cost-calc__value cost-calc__value_green'>
                            +{parcel.insuranceCost || 0} ₽
                        </div>
                    </div>}
                </div>
                {selectedServiceLines.length > 0 && <div className='cost-calc__params'>
                    <div>
                        Доп. услуги
                    </div>
                    {selectedServiceLines.map(s => (
                            <div className='cost-calc__param' key={s.code}>
                                <div>{s.name}</div>
                                <div className='cost-calc__value cost-calc__value_green'>
                                    +{s.cost.toFixed(2)} ₽
                                </div>
                            </div>
                        ))}
                </div>}
                    {/*{parcel.feeUsingYourCarrier > 0 && <div className='cost-calc__param'>*/}
                    {/*    <div>*/}
                    {/*        Плата за пользование своим перевозчиком*/}
                    {/*    </div>*/}
                    {/*    <div className='cost-calc__value cost-calc__value_green'>*/}
                    {/*        +{parcel.feeUsingYourCarrier || 0} ₽*/}
                    {/*    </div>*/}
                    {/*</div>}*/}
                <div className='cost-calc__params'>
                    {parcel.createByManagerCost > 0 && <div className='cost-calc__param'>
                        <div>
                            Создание заказа клиентским менеджером
                        </div>
                        <div className='cost-calc__value cost-calc__value_green'>
                            +{parcel.createByManagerCost || 0} ₽
                        </div>
                    </div>}
                    {parcel.discountForCustomer > 0 && <div className='cost-calc__param'>
                        <div>
                            Скидка для клиента
                        </div>
                        <div className='cost-calc__value cost-calc__value_red'>
                            -{parcel.discountForCustomer || 0} ₽
                        </div>
                    </div>}
                </div>
                <div className='cost-calc__total'>
                    {costFormat(parcel.actualDeliveryCost || parcel.deliveryCost || 0)} ₽
                </div>
            </div>
        </div>
    </div>
};

export default ActualCostBlock;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/actualCostBlock.jsx